import { cropName } from 'helpers/cropName'
import { FC } from 'react'
import {
  Avatar as AvatarUI,
  AvatarFallback,
  AvatarImage,
  cn,
} from '@wellesley/ui'
import { LucideIcon } from 'lucide-react'

export type AvatarProps = {
  name?: string
  Icon?: string | null | LucideIcon
  className?: string
  isActive?: boolean
  variant?: 'default' | 'square'
  isCustomIcon?: boolean
}

export const Avatar: FC<AvatarProps> = ({
  name,
  Icon,
  className,
  isActive,
  variant = 'default',
  isCustomIcon = false,
}) => {
  const isCircleVariant = variant === 'default'
  const isImage = typeof Icon === 'string' || !Icon
  return (
    <AvatarUI
      className={cn(
        'flex size-m items-center justify-center rounded-m hover:bg-gray-100',
        {
          'ring-2 ring-blue-500 ring-offset-2 ring-offset-white':
            isActive && isImage && !isCustomIcon,
        },
        className,
      )}
    >
      {isImage ? (
        <>
          {Icon && (
            <AvatarImage
              src={Icon}
              alt="app-avatar"
              className={cn({ 'size-xxs': isCustomIcon })}
            />
          )}
          <AvatarFallback
            className={cn('bg-blue-500 text-sm font-medium text-white', {
              'rounded-m': !isCircleVariant,
            })}
          >
            {name ? cropName(name) : ''}
          </AvatarFallback>
        </>
      ) : (
        <div
          className={cn('flex h-full w-full items-center justify-center ', {
            'bg-gray-100': isActive,
          })}
        >
          <Icon
            size={20}
            className={cn('text-gray-500', {
              'text-gray-900': isActive,
            })}
          />
        </div>
      )}
    </AvatarUI>
  )
}
